export interface INutrition {
  nutrition_id: string;
  name: string;
  value_low: number;
  value_high: number;
}

interface IAllergenChild {
  allergen_id: string;
  name: string;
}

interface IAllergen extends IAllergenChild {
  child_allergens: IAllergenChild[] | null;
}

export type InventoryItemType = 'RECIPE' | 'GOOD';

export const INVENTORY_TYPE_LABEL: Record<InventoryItemType, string> = {
  RECIPE: 'Recipe',
  GOOD: 'Good',
};

export interface IInventoryItemDetails {
  recipe_id: string;
  name: string;
  type: InventoryItemType;
  description?: string;
  code?: string | null;
  claims?: string[];
  is_vegan: boolean;
  is_vegetarian: boolean;
  contains_alcohol: boolean;
  nutritional_information: INutrition[];
  allergens_information: IAllergen[];
}
